import {
  INSIGHTS_FACEBOOK_SELECTABLE_DATE_PRESETS,
  INSIGHTS_TIKTOK_SELECTABLE_DATE_PRESETS,
  type InsightsFacebookSelectableDatePreset,
} from '@magicbrief/common';

const facebookDatePresets: (InsightsFacebookSelectableDatePreset | 'custom')[] =
  [
    ...(Object.keys(
      INSIGHTS_FACEBOOK_SELECTABLE_DATE_PRESETS
    ) as InsightsFacebookSelectableDatePreset[]),
    'custom' as const,
  ];

const tiktokDatePresets = [
  ...(Object.keys(
    INSIGHTS_TIKTOK_SELECTABLE_DATE_PRESETS
  ) as InsightsFacebookSelectableDatePreset[]),
  'custom' as const,
];

export function getDatePresetsForPlatform(platform: 'facebook' | 'tiktok') {
  switch (platform) {
    case 'facebook':
      return facebookDatePresets;
    case 'tiktok':
      return tiktokDatePresets;
  }
}
